export default __webpack_public_path__ + "static/media/sandbox.fbb01226.webp";